var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainWrapper"},[_c('div',{staticClass:"pulse-circle"},[_c('IconLogoSpeedio')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }